
import Vue, { PropType } from 'vue';
import Modal from '@/components/modal/Modal.vue';
import { required } from 'vuelidate/lib/validators';
import { Validation } from 'vuelidate/vuelidate';
import { Device } from '@/interfaces/locations';
import { SelectMenu } from '@/interfaces/global';

interface DeviceForm {
	device: number | null;
}

export default Vue.extend({
	components: {
		Modal,
	},
	data() {
		return {
			assignDeviceForm: {
				device: null,
			},
		} as {
			assignDeviceForm: DeviceForm;
		};
	},
	validations: {
		assignDeviceForm: {
			device: {
				required,
			},
		},
	},
	props: {
		unassignedLuminaires: { type: Array as PropType<Device[]>, default: (): Device[] => [] },
		unassignedSwitches: { type: Array as PropType<Device[]>, default: (): Device[] => [] },
		assignableEmergencySwitches: { type: Array as PropType<Device[]>, default: (): Device[] => [] },
		sensorList: { type: Array as PropType<Device[]>, default: (): Device[] => [] },
	},
	computed: {
		luminaireOptions(): SelectMenu[] {
			return this.unassignedLuminaires.map((luminaires) => {
				return {
					value: luminaires.id,
					text: luminaires.name,
				};
			});
		},

		switchOptions(): SelectMenu[] {
			let filteredSwitches: Device[] = [];
			let filteredDuplicates = this.unassignedSwitches.filter(
				(val: Device) => val.type !== 'Emergency switch'
			);

			if (this.sensorList.some((device) => device.type === 'Emergency switch')) {
				filteredSwitches = filteredDuplicates;
			} else {
				filteredSwitches = [...filteredDuplicates, ...this.assignableEmergencySwitches];
			}

			return filteredSwitches.map((switches) => {
				return {
					value: switches.id,
					text: switches.name,
				};
			});
		},
	},
	methods: {
		closeModal(): void {
			this.$bvModal.hide('modal-assign-device');
		},

		confirmModal(): void {
			this.$v.assignDeviceForm.$touch();

			if (this.$v.assignDeviceForm.$anyError) {
				return;
			}

			this.$emit('assignDevice', this.assignDeviceForm.device);
		},

		resetModal(): void {
			this.assignDeviceForm = {
				device: null,
			};
			this.$v.assignDeviceForm.$reset();
			this.$emit('reset');
		},

		validateState(validation: Validation): boolean | null {
			const { $dirty, $error }: { $dirty: boolean; $error: boolean } = validation;
			return $dirty ? !$error : null;
		},
	},
});
